import {createContext, FC, PropsWithChildren, useContext} from 'react'
import {createPortal} from 'react-dom'

export const FormStepHeaderActionContext = createContext<HTMLElement | null>(null)

export const FormStepHeaderAction: FC<PropsWithChildren> = ({children}) => {
  const slot = useContext(FormStepHeaderActionContext)

  return slot ? createPortal(children, slot) : null
}
